import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, ButtonGroup, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  saveManageBankAccount,
  deleteManageBankAccount,
  getManageBankAccount,
  editManageBankAccount,
} from '../../redux/actions/manageBankAccount'
import notification from '../../utils/notification'
import PreviewButton from '../../components/buttons/previewButton/PreviewButton'
import FillingListReportTable from './FillingListReportTable'
import { ExportEfillingReport, searchEfillingReport } from '../../redux/actions/eFilling'
import { REQUEST_DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import { downloadFile } from '../../utils/fileUtil'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function FillingListReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const [selectRowData, setSelectRowData] = useState()
  const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isAddBankAccount, setIsAddBankAccount] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const projectCode = sessionStorage.getItem('projectCode')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const history = useHistory()
  const [test, setTest] = useState(false)
  const pageNumber = 0
  const pageSize = 0
  const [searchData, setSearchData] = useState()

  useEffect(() => {
    //setProjectCode(projectCode || '')
  }, [])

  const handleGetSchemaEdit = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      // const response = await editManageBankAccount(id)
      // setSelectRowData(response.model)
      // console.log('responseEdit==>', id)
      // setSelectRowData(id)
      // console.log('responseEdit', response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSelectRowData = async (rowData) => {
    // console.log('handleSelectRowData===>', rowData)
    setSelectRowData(rowData)
    setIsAddBankAccount(false)
    setIsExpanded(false)
    handleGetSchemaEdit(rowData.id)
  }

  const handleSelectView = (rowData) => {
    // console.log('handleSelectView===> ', rowData)

    rowData.projectCode = formSchema?.projectCode

    //sessionSetItemObj('param', rowData)
    // sessionSetItemObj('projectCode', rowData)
    const xurl = `${process.env.REACT_APP_SERVER_URL}${pathname.incomeAndExpense.ViewFileseFilling}`

    window.open(xurl, '_blank')

    // history.push({
    //   pathname: pathname.incomeAndExpense.ViewFileseFilling,
    // })
  }

  const handleOnSearchEFilling = async (
    txtSubmisStatusVal,
    submitStartDate,
    submitEndDate,
    taxMonthVal,
    projectCodeVal,
    txtModelTypeVal
  ) => {
    const request = {
      submitStartDate: submitStartDate ? moment(submitStartDate).format(REQUEST_DATE_FORMAT) : '',
      submitEndDate: submitEndDate ? moment(submitEndDate).format(REQUEST_DATE_FORMAT) : '',
      projectCode: projectCodeVal || '',
      taxMonth: taxMonthVal ? moment(taxMonthVal).format(REQUEST_DATE_FORMAT) : '',
      submitStatus: txtSubmisStatusVal || '',
      withholdingType: getValueFromOptions(formSchema.forms.modelType.options, txtModelTypeVal),
    }
    setSearchData(request)
    // console.log('requestOnSearch ==>', request)
    handleSearchEFilling(request)
  }

  const handleSearchEFilling = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      // console.log('request==>api', request)
      const response = await searchEfillingReport(request, pageNumber, pageSize)
      // console.log('handleSearchEFilling==>', response)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onExport = async (
    txtSubmisStatusVal,
    submitStartDate,
    submitEndDate,
    taxMonthVal,
    projectCodeVal,
    txtModelTypeVal,
    pageNumber,
    pageSize
  ) => {
    const request = {
      submitStartDate: submitStartDate ? moment(submitStartDate).format(REQUEST_DATE_FORMAT) : '',
      submitEndDate: submitEndDate ? moment(submitEndDate).format(REQUEST_DATE_FORMAT) : '',
      projectCode: projectCodeVal || '',
      taxMonth: taxMonthVal ? moment(taxMonthVal).format(REQUEST_DATE_FORMAT) : '',
      submitStatus: txtSubmisStatusVal || '',
      withholdingType:
        getValueFromOptions(formSchema.forms.modelType.options, txtModelTypeVal) || '',
      pageNumber: pageNumber || '0',
      pageSize: pageSize || '0',
    }
    // console.log('requestonExport ==>', request)
    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await ExportEfillingReport(request)

      if (file) {
        downloadFile(file, file.name || `รายงานการยื่นแบบและชำระภาษีออนไลน์`)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      //let errorJson = JSON.parse(await e.response.data.text())
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }
  return (
    <>
      <Panel
        shaded
        // collapsible
        defaultExpanded
        bordered
        header={'รายงานการยื่นแบบและชำระภาษีออนไลน์ (e-Filing)'}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <FillingListReportTable
          schema={formSchema}
          data={formSchema?.eFillingReportListValues}
          loading={isLoading}
          onSelectToView={handleSelectView}
          onSelect={handleSelectRowData}
          isViewMode={formSchema?.disabled}
          onSearch={handleOnSearchEFilling}
          onCancel={() => {
            handleSearchEFilling({})
          }}
          onExport={onExport}
          projectCode={projectCode}
        />
      </Panel>
      <br /> <br /> <br />
      {(isAddBankAccount || selectRowData) && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={isAddBankAccount ? 'เพิ่มข้อมูลยื่น eFilling' : 'แก้ไข'}
          bordered
          expanded={isExpandedForm}
          onSelect={() => {
            setIsExpandedForm(!isExpandedForm)
          }}
        >
          <hr />
          {isError && <Message showIcon type="error" description={isError} />}
        </Panel>
      )}
    </>
  )
}
